import { useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { Form, InputGroup, Tab, Tabs } from "react-bootstrap";

import trash_img from '../../../assets/images/trash.svg'
import add_img from '../../../assets/images/add.svg'

import correct_img from '../../../assets/images/questions/correct.svg'
import wrong_img from '../../../assets/images/questions/wrong.svg'
import missing_img from '../../../assets/images/questions/missing.svg'
import UploadButton from '../../../components/UploadButton';
import { API_URL } from '../../../config/constants'

export default function ExamProctoring (props) {

     const t = useSelector(selectTranslations)

    const handleUpdateData = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        props.onExamDataChange({
            ...props.examData,
            [name]: value === "null" ? null : value
        })
    }

    const handleUpdateModuleData = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        let _modules = structuredClone(props.examData?.modules)
        _modules[0]={
            ..._modules[0],
            [name]: e.target.value
        }
        props.onExamDataChange({
            ...props.examData,
            modules: _modules
        })
    }

    const addStep = () => {
        props.onExamDataChange({
            ...props.examData,
            additional_results_step: [...props.examData?.additional_results_step || [], {
                text: "",
                icon_url: "",
                cta: {
                    text: "",
                    url: ""
                }
            }]
        })
    }

    const removeStep = (index) => {
        let _additional_results_step = structuredClone(props.examData?.additional_results_step)
        _additional_results_step.splice(index, 1)
        props.onExamDataChange({
            ...props.examData,
            additional_results_step: _additional_results_step
        })
    }

    const handleUpdateStepsData = (e, index) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        let _additional_results_step = structuredClone(props.examData?.additional_results_step)
        _additional_results_step[index]={
            ..._additional_results_step[index],
            [name]: e.target.value
        }
        props.onExamDataChange({
            ...props.examData,
            additional_results_step: _additional_results_step
        })
    }

    const handleUpdateStepImage = (value, index) => {
        let _additional_results_step = structuredClone(props.examData?.additional_results_step)
        _additional_results_step[index]={
            ..._additional_results_step[index],
            'icon_url': value
        }
        props.onExamDataChange({
            ...props.examData,
            additional_results_step: _additional_results_step
        })
    }

    const handleUpdateStepCta = (e, index) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        let _additional_results_step = structuredClone(props.examData?.additional_results_step)
        _additional_results_step[index]={
            ..._additional_results_step[index],
            cta: {
                ..._additional_results_step[index].cta,
                [name]: e.target.value
            }
        }
        props.onExamDataChange({
            ...props.examData,
            additional_results_step: _additional_results_step
        })
    }

    const defaultProctoringSetting = {
        authorizationType: "",
        screenRecording: false,
        videoRecording: false,
        proctoringType: "Lite",
        pauseResumeTest: false,
        endTest: false,
        SecondaryCamera: false,
        sessionExpiryTime: 1800
    }

    const handleUpdateProctoringSetting = (e) => {
        const target = e.target
        const name = target.name
        let value = target.type === 'checkbox' ? target.checked : target.value
        if (name === 'sessionExpiryTime') {
            if (value === '') {
                value = ''
            } else {
                const parsed = parseInt(value)
                if (isNaN(parsed)) {
                    value = ''
                } else {
                    value = Math.min(1800, Math.max(0, parsed))
                }
            }
        }
        const current = props.examData?.proctoring_setting || defaultProctoringSetting
        props.onExamDataChange({
            ...props.examData,
            proctoring_setting: {
                ...current,
                [name]: value
            }
        })
    }

    const handleRemoveStepImage = (index) => {
        let _additional_results_step = structuredClone(props.examData?.additional_results_step)
        _additional_results_step[index]={
            ..._additional_results_step[index],
            icon_url: ''
        }
        props.onExamDataChange({
            ...props.examData,
            additional_results_step: _additional_results_step
        })
    }

 
    return (
        <div className='exams-step-6'>
            <div className="info_card">
                <h2>{t.exam.proctoring_setting}</h2>
                <Form.Check // prettier-ignore
                    type="switch"
                    name='proctoring_required'
                    checked={props?.examData?.proctoring_required}
                    onChange={handleUpdateData}
                    id="custom-switch"
                    label={t.exam.proctoring.required}
                />
                <hr />
                <div className='row align-items-center'>
                    <div className='col-6'>
                        <Form.Check // prettier-ignore
                            type="switch"
                            name='proctoring_review_needed'
                            checked={props?.examData?.proctoring_review_needed}
                            onChange={handleUpdateData}
                            id="custom-switch"
                            label={t.exam.proctoring.needs_review}
                        />
                    </div>
                    <div className='col-6'>
                        <Form.Group controlId="description" className='mt-2'>
                            <Form.Label>{t.exam.proctoring.proctoring_threshold}*</Form.Label>
                            <Form.Control type="number" value={props.examData.proctoring_threshold || ''} name="proctoring_threshold" placeholder={t.exam.proctoring.proctoring_threshold} onChange={handleUpdateData} />
                        </Form.Group>
                    </div>
                </div>
                <hr />
                {(() => { const p = props.examData?.proctoring_setting || defaultProctoringSetting; return (
                    <div className='row'>
                        <div className='col-6'>
                            <Form.Group controlId="authorizationType" className='mt-2'>
                                <Form.Label>Authorization type</Form.Label>
                                <Form.Select name="authorizationType" value={p.authorizationType || ''} onChange={handleUpdateProctoringSetting}>
                                    <option value="">Nessuno</option>
                                    <option value="Photo">Photo</option>
                                    <option value="Video">Video</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className='col-6'>
                            <Form.Group controlId="proctoringType" className='mt-2'>
                                <Form.Label>Proctoring type</Form.Label>
                                <Form.Select name="proctoringType" value={p.proctoringType || 'Lite'} onChange={handleUpdateProctoringSetting}>
                                    <option value="Lite">Lite</option>
                                    <option value="Live">Live</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className='col-6 mt-3'>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="screenRecording"
                                name="screenRecording"
                                label={'Screen recording'}
                                onChange={handleUpdateProctoringSetting}
                                checked={p.screenRecording || false}
                            />
                        </div>
                        <div className='col-6 mt-3'>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="videoRecording"
                                name="videoRecording"
                                label={'Video recording'}
                                onChange={handleUpdateProctoringSetting}
                                checked={p.videoRecording || false}
                            />
                        </div>
                        <div className='col-6 mt-3'>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="pauseResumeTest"
                                name="pauseResumeTest"
                                label={'Pause/Resume test'}
                                onChange={handleUpdateProctoringSetting}
                                checked={p.pauseResumeTest || false}
                            />
                        </div>
                        <div className='col-6 mt-3'>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="endTest"
                                name="endTest"
                                label={'End test'}
                                onChange={handleUpdateProctoringSetting}
                                checked={p.endTest || false}
                            />
                        </div>
                        <div className='col-6 mt-3'>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="SecondaryCamera"
                                name="SecondaryCamera"
                                label={'Secondary camera'}
                                onChange={handleUpdateProctoringSetting}
                                checked={p.SecondaryCamera || false}
                            />
                        </div>
                        <div className='col-6'>
                            <Form.Group controlId="sessionExpiryTime" className='mt-2'>
                                <Form.Label>Session expiry time (sec)</Form.Label>
                                <Form.Control type="number" min={0} max={1800} value={p.sessionExpiryTime ?? 1800} name="sessionExpiryTime" placeholder={'1800'} onChange={handleUpdateProctoringSetting} />
                            </Form.Group>
                        </div>
                    </div>
                )})()}
            </div>
            <div className="info_card">
                <h2>{t.exam.additional_steps}</h2>
                {
                    props.examData?.additional_results_step?.map((step, index)=>{
                        return(
                            <div className='d-flex align-items-center mb-2 pb-2 border-bottom flex-wrap'>
                                <Form.Group controlId="description" className=''>
                                    <Form.Label>{t.exam.additional_step.text}</Form.Label>
                                    <Form.Control className='' type="text" value={step.text || ''} name="text" onChange={(e)=>handleUpdateStepsData(e,index)} />
                                </Form.Group>
                            {
                                step?.icon_url ? (
                                        <div className='d-flex align-items-center ms-2'>
                                        <img src={`${API_URL}${step.icon_url}`} alt='' style={{ maxHeight: 40 }} />
                                            <img src={trash_img} className='ms-2' onClick={()=>handleRemoveStepImage(index)} />
                                            <UploadButton onUpload={(e)=>handleUpdateStepImage(e, index)} type='personalization' label={t.buttons.upload_file} accept='image/*' showProgress={true} />
                                        </div>
                                    ) : (
                                        <UploadButton onUpload={(e)=>handleUpdateStepImage(e, index)} type='personalization' label={t.buttons.upload_file} accept='image/*' showProgress={true} />
                                    )
                                }
                                
                                <Form.Group controlId="description" className=''>
                                    <Form.Label>{t.exam.additional_step.text}</Form.Label>
                                    <Form.Control className='' type="text" value={step?.cta?.title || ''} name="title" onChange={(e)=>handleUpdateStepCta(e,index)} />
                                </Form.Group>
                                <Form.Group controlId="description" className=''>
                                    <Form.Label>{t.exam.additional_step.text}</Form.Label>
                                    <Form.Control className='' type="text" value={step?.cta?.url || ''} name="url" onChange={(e)=>handleUpdateStepCta(e,index)} />
                                </Form.Group>
                                <img src={trash_img} className='ms-2' onClick={()=>removeStep(index)} />
                            </div>
                        )
                    })
                }
                <button onClick={addStep}>
                    <img src={add_img} alt='' />
                    {t.exam.additional_step.add_step}
                </button>
            </div>
            <>
            </>
        </div>
        
    )
}